export class User {
  constructor(_context) {
    this._context = _context;
  }
  onLoadData() {
    this._context.$store.dispatch("user/getAll", {
      method: "GET",
      endpoint: "user",
      query_params: {
        format: "json",
      },
    });
  }
}
